/**
 * Formats real-world size measurements to human-readable string with appropriate units
 * Converts meters to either millimeters (if < 1m) or meters
 * @param meters - Size in meters
 * @returns Formatted string (e.g., '500 mm' or '2.5 m')
 */
export function formatRealSize(meters: number): string {
  if (meters < 1) {
    return `${Math.round(meters * 1000)} mm`;
  }
  return `${(meters).toFixed(2)} m`;
}

/**
 * Cap a property-panel number at 2 decimal places so float drift
 * (e.g. rotation 89.99999999999999) never reaches the inputs.
 */
export function roundToTwoDecimals(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.round(value * 100) / 100;
}
